import { render } from "./IpAddress.vue?vue&type=template&id=8f56e5d6"
import script from "./IpAddress.vue?vue&type=script&lang=js"
export * from "./IpAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__